import script from "./PopupAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupAuth.vue?vue&type=script&setup=true&lang=ts"

import "./PopupAuth.vue?vue&type=style&index=0&id=bc219366&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc219366"]])

export default __exports__